export const ABOUT_LINK_EN =
  'https://www.cabonlinegroup.com/en/about/cabonline/info';
export const ABOUT_LINK_SV =
  'https://www.cabonlinegroup.com/om-oss/cabonline/info';

export const PRIVACY_LINK_SV =
  'https://www.cabonline.com/integritypolicy-servicetrips';

export const TERMS_LINK_SV = 'https://www.cabonline.com/terms-servicetrips';

export const ACCESSIBILITY_DECLARATION_LINK_EN =
  'https://www.cabonline.com/accessibility-servicetrips?language=English';
export const ACCESSIBILITY_DECLARATION_LINK_SV =
  'https://www.cabonline.com/accessibility-servicetrips?language=Svenska';
export const ACCESSIBILITY_DECLARATION_LINK_NO =
  'https://www.cabonline.com/accessibility-servicetrips?language=Norska';

export const COOKIES_LINK = 'https://www.cabonline.com/cookies';

export const CUSTOMER_SERVICE_EMAIL = 'serviceresor@cabonline.com';
